import { P2Button, P2TextDescription, P2TextLabel } from 'react-bootstrap-common-script'
import { Separator } from '../separator'
import MoreDetailsIcon from '../../assets/svg/more-details'
import './proposed-loan-repayment-plan-section.scss'
import { StageDProposedFinancialPlan } from '../../models/classes/stage-d/Review-Application.class';
import { useEffect, useState } from 'react';
import { Helpers } from '../../utils/helper';

interface ProposedLoanRepaymentPlanSectionInterface {
  proposedFinancialPlanData?: StageDProposedFinancialPlan;
}

const ProposedLoanRepaymentPlanSection = ({proposedFinancialPlanData}: ProposedLoanRepaymentPlanSectionInterface) => {
  const [loanCommencementDate, setLoanCommencementDate] = useState<string>("");
  const [instalmentCommencementDate, setInstalmentCommencementDate] = useState<string>("");

  useEffect(() => {
    if (proposedFinancialPlanData?.actual_completion_date !== undefined) {
      setLoanCommencementDate(proposedFinancialPlanData.actual_completion_date);
    } else if (proposedFinancialPlanData?.scheduled_completion_date !== undefined) {
      setLoanCommencementDate(proposedFinancialPlanData.scheduled_completion_date);
    } else if (proposedFinancialPlanData?.tentative_completion_date !== undefined) {
      setLoanCommencementDate(proposedFinancialPlanData.tentative_completion_date);
    }
  }, [proposedFinancialPlanData])

  useEffect(() => {
    if (loanCommencementDate !== "") {
      const originalDate = new Date(loanCommencementDate);
      if (originalDate.getDate() !== 1) {
        originalDate.setDate(1);
      }
      originalDate.setMonth(originalDate.getMonth() + 2);
      setInstalmentCommencementDate(originalDate.toISOString());
    }
  }, [loanCommencementDate])

  return (
    <div>
      <P2TextDescription color='#333' title={"Proposed Loan Repayment Plan"} />

      <div className='polymer-stage-d-financial-plan-container__info'>
        <P2TextLabel fontSize={"1.125rem"} bold={700} label={"Loan Amount"} />
        <P2TextLabel fontSize={"1.125rem"} bold={400} label={Helpers.amountToTwoDecimals(proposedFinancialPlanData?.proposed_payment_allocation_payable_loan)} />
      </div>

      <div className='polymer-stage-d-financial-plan-container__info'>
        <P2TextLabel fontSize={"1.125rem"} bold={700} label={"Repayment Period"} />
        <P2TextLabel fontSize={"1.125rem"} bold={400} label={proposedFinancialPlanData?.repayment_period} />
      </div>

      <div className='polymer-stage-d-financial-plan-container__info'>
        <P2TextLabel 
          delay={1500}
          fontSize={"1.125rem"} 
          bold={700} 
          label={"Interest Rate"} 
          hasTooltip 
          tooltipContent={
            <>
              <p>Concessionary rate is pegged at 0.1% above the prevailing CPF interest rate.</p>
              <a className="tooltip-more-details" href="#" target="_blank" rel="noreferrer">
                <p>More Details </p>
                <MoreDetailsIcon />
              </a>
            </>
          } 
        />
        <P2TextLabel fontSize={"1.125rem"} bold={400} label={proposedFinancialPlanData?.repayment_interest_rate + "%"} />
      </div>

      <div className='polymer-stage-d-financial-plan-container__info'>
        <P2TextLabel fontSize={"1.125rem"} bold={700} label={"Loan Commencement Date"} />
        <P2TextLabel fontSize={"1.125rem"} bold={400} label={Helpers.formatDate(loanCommencementDate, "short")} />
      </div>

      <div className='polymer-stage-d-financial-plan-container__info'>
        <P2TextLabel fontSize={"1.125rem"} bold={700} label={"Instalment Commencement Date"} />
        <P2TextLabel fontSize={"1.125rem"} bold={400} label={Helpers.formatDate(instalmentCommencementDate, "short")} />
      </div>

      <div className='polymer-stage-d-financial-plan-table'>
        <div className='polymer-stage-d-financial-plan-table__header-row'>
          <p>Monthly Instalment</p>
          <p>{Helpers.amountToTwoDecimals(proposedFinancialPlanData?.monthly_installment)} / month</p>
        </div>

        <Separator variant='solid' />
        <div className='polymer-stage-d-financial-plan-table__primary-row polymer-stage-d-financial-plan-table__primary-row_payable-cpf'>
          <P2TextLabel hasTooltip={true} tooltipContent={<><p>Each owner's amunt falls within their monthly CPF OA contribution.</p></>} label={"Payable by CPF"} />
          <p>{Helpers.amountToTwoDecimals(proposedFinancialPlanData?.monthly_installment_by_cpf)} / month</p>
        </div>
        {
          proposedFinancialPlanData?.monthly_installment_by_cpf_owner?.map((owner) => {
            return (
              <div className='polymer-stage-d-financial-plan-table__sub-row'>
                <p>{owner.name}</p>
                <p>{Helpers.amountToTwoDecimals(owner.amount)} / month</p>
              </div>
            )
          })
        }
        <div className='polymer-stage-d-financial-plan-table__primary-row polymer-stage-d-financial-plan-table__primary-row_payable-cpf'>
          <p>Payable by Cash</p>
          <p>{Helpers.amountToTwoDecimals(proposedFinancialPlanData?.monthly_installment_by_cash)} / month</p>
        </div>
      </div>


      <div className='polymer-stage-d-financial-plan-container__content-text'>
        <P2TextDescription color='#333' description={"The Home Protection Scheme (HPS) is mandatory if you use your CPF savings to pay your monthly housing instalments. The HPS protects you from losing your HDB flat in the event of death, terminal illness or permanent disability."} />
      </div>

      <div className='polymer-stage-d-financial-plan-table'>
        <div className='polymer-stage-d-financial-plan-table__header-row'>
          <p>Home Protection Scheme Coverage</p>
          <p></p>
        </div>

        <Separator variant='solid' />

        {
          proposedFinancialPlanData?.home_protection_schemes?.map((scheme) => {
            return (
              <div className='polymer-stage-d-financial-plan-table__primary-row'>
                <p>{scheme.partyName}</p>
                <p>{scheme.coverage}%</p>
              </div>
            )
          })
        }
      </div>

    </div>
  )
}

export default ProposedLoanRepaymentPlanSection